import { Dimensions, Platform, StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: theme => ({
    flex: 1,
    backgroundColor: theme.colors.backgroundColorTwo,
  }),
  mapContainer: {
    flex: 1,
  },
  StoresCardsList: insets => ({
    position: 'absolute',
    paddingBottom: 0,
    bottom: insets.bottom,
    width: '100%',
    paddingBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 180 : 100
  }),
  mapOverlay: theme => ({
    position: 'absolute',
    backgroundColor: theme.colors.backgroundColorThree,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flex: 1
  }),
  errorBackgroundStyle: {
    backgroundColor: 'transparent'
  }
})
